import "./index.css";

const PageHeader = (props) => (
  <div className="page-header-container">{props.children}</div>
);

export default PageHeader;
